var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 190,
    viewBox: "0 0 251 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.939 119.252L99.1775 119.067C95.5877 119.057 92.686 116.138 92.6966 112.548L92.9535 25.2809C92.9641 21.6911 95.8827 18.7899 99.4725 18.8008L141.275 18.9276C142.995 18.9328 144.644 19.6201 145.859 20.8387L164.762 39.8003C165.981 41.0235 166.664 42.6818 166.659 44.409L166.458 112.772C166.447 116.362 163.529 119.263 159.939 119.252Z",
    fill: "white",
    stroke: "#001628"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.622 34.4355L144.662 20.8464C144.663 20.4013 145.202 20.1797 145.516 20.495L165.105 40.1439C165.419 40.4596 165.195 40.9982 164.749 40.9968L151.103 40.9554C147.513 40.9444 144.611 38.0254 144.622 34.4355Z",
    fill: "#001628",
    stroke: "#001628"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.400662,
    y: 0.400629,
    width: 34.5542,
    height: 0.801255,
    transform: "matrix(1 4.16614e-06 8.56064e-05 1 111.678 49.8536)",
    fill: "#001628",
    stroke: "#001628",
    strokeWidth: 0.801255
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.400663,
    y: 0.40063,
    width: 34.5542,
    height: 0.801257,
    transform: "matrix(1 4.3907e-06 8.60961e-05 1 111.678 58.4)",
    fill: "#001628",
    stroke: "#001628",
    strokeWidth: 0.801257
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.400663,
    y: 0.40063,
    width: 34.5542,
    height: 0.801256,
    transform: "matrix(1 3.97524e-06 8.56782e-05 1 111.679 66.9465)",
    fill: "#001628",
    stroke: "#001628",
    strokeWidth: 0.801256
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.40066,
    y: 0.400627,
    width: 34.5542,
    height: 0.801252,
    transform: "matrix(1 3.8001e-06 8.55025e-05 1 111.679 75.4933)",
    fill: "#001628",
    stroke: "#001628",
    strokeWidth: 0.801252
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.643 68.2012V184.576C215.643 185.769 215.162 186.915 214.304 187.761C213.445 188.607 212.278 189.083 211.061 189.083H61.7201C60.5024 189.083 59.336 188.607 58.4772 187.761C57.6186 186.915 57.1377 185.769 57.1377 184.576V90.9217C57.1377 90.9217 57.1377 90.9217 57.1377 90.9217C57.1378 89.7289 57.6187 88.5834 58.4773 87.7376C59.3361 86.8916 60.5024 86.415 61.7201 86.4149C61.7201 86.4149 61.7201 86.4149 61.7201 86.4149H151.297C152.776 86.4149 154.195 85.8365 155.242 84.8046C156.29 83.7725 156.88 82.371 156.88 80.9081V68.2012C156.88 67.0084 157.361 65.8629 158.219 65.0171C159.078 64.1711 160.244 63.6945 161.462 63.6945H211.061C212.278 63.6945 213.445 64.1711 214.304 65.0171C215.162 65.8629 215.643 67.0084 215.643 68.2012Z",
    fill: "#126A5A",
    stroke: "#001628"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.875 99.9999C67.1667 110.417 90.3661 130.338 120.644 123.317C158.492 114.54 162.013 91.2807 184.897 91.2808C203.381 91.2808 211.302 101.813 213.503 104.446",
    stroke: "#A4B6B4",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.285 87.77C125.925 98.7413 124.605 121.123 113.603 132.533C92.0297 154.906 72.2345 154.036 58.5918 154.036",
    stroke: "#A4B6B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.292 186.458C158.934 181.192 181.376 173.346 185.777 160.619C193.82 137.36 176.093 107.748 162.453 124.633C149.69 140.432 178.736 151.052 185.777 153.159C196.339 156.318 200.839 156.414 214.042 157.292",
    stroke: "#A4B6B4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.eacadb2937d0e507219b1e2359ead956.svg";
export { ForwardRef as ReactComponent };